import { createIconComponent } from '../../factory/create-icon-component';
export const DenmarkIcon = createIconComponent(
  'DenmarkIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28276)">
      <path d="M22.9999 5.00012H0.999878V20H22.9999V5.00012Z" fill="#D80027" />
      <path
        d="M9.24988 5H6.49988V11.0936H0.999878V13.906H6.49988V19.9996H9.24988V13.906H22.9999V11.0936H9.24988V5Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28276">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
